var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54709 13.8279C2.61653 12.2579 2.29103 10.4023 2.6317 8.60931C2.97237 6.81633 3.95578 5.20936 5.39731 4.09007C6.83883 2.97078 8.63934 2.41615 10.4608 2.5303C12.2823 2.64446 13.9995 3.41954 15.29 4.71004C16.5805 6.00055 17.3556 7.71773 17.4697 9.53921C17.5839 11.3607 17.0292 13.1612 15.91 14.6027C14.7907 16.0442 13.1837 17.0277 11.3907 17.3683C9.59775 17.709 7.74208 17.3835 6.17209 16.4529V16.4529L3.57834 17.1873C3.47207 17.2184 3.3594 17.2203 3.25213 17.1929C3.14487 17.1654 3.04696 17.1097 2.96866 17.0314C2.89037 16.9531 2.83459 16.8552 2.80715 16.7479C2.77971 16.6406 2.78163 16.528 2.81271 16.4217L3.54709 13.8279Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircle);
export default __webpack_public_path__ + "static/media/chat-circle.d6de4a021a17d76b91babbaea67aa0d4.svg";
export { ForwardRef as ReactComponent };